
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useArtists } from '../../hooks/useArtists';

const PaintersPage = () => {
  const { artists } = useArtists();

  // Guard against undefined or null artists array
  const painters = Array.isArray(artists)
    ? artists.filter((a) => a.type === 'painter')
    : [];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-8 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold mb-6">Painters</h1>
          <p className="text-xl text-gray-700 max-w-3xl leading-relaxed">
            저희 페인터들은 캔버스 위에 감정과 이야기를 담아내는 순수 예술가입니다. 유화,
            수채화, 수묵화부터 혼합 매체까지, 각자의 독창적인 시각으로 아름다운 작품 세계를
            펼쳐냅니다.
          </p>
        </div>
      </section>

      {/* Artists Grid */}
      <section className="py-20 px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {painters.map((artist) => (
              <Link
                key={artist.id}
                to={`/artist/${artist.slug}`}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg mb-5 aspect-[4/5]">
                  <img
                    src={artist.image}
                    alt={artist.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                    <div>
                      <p className="text-white text-sm font-medium mb-2">
                        View Portfolio
                      </p>
                      <i className="ri-arrow-right-line text-white text-xl"></i>
                    </div>
                  </div>
                </div>
                <h3 className="text-2xl font-bold mb-2">{artist.name}</h3>
                <p className="text-sm text-gray-600">{artist.specialty}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PaintersPage;
